var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.ApplicationUserGroups},[_c('p',[_vm._v(" The following user groups are bound to "+_vm._s(_vm.item.name)+". Users will have access in their User Portal. ")]),_c('UserGroupItemTable',{ref:"itemTable",attrs:{"boundItemsUrl":_vm.boundItemsUrl,"inDetailsAsidePanel":true,"panelType":_vm.panelType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }